import isMobileFn from "is-mobile";
export var isMobile = isMobileFn({ tablet: true, featureDetect: true });
